import { LayoutManager } from "./layout";
import { IGameConfig, ILegacyGameConfig } from "./interface";

export const lm = (gameConfig: IGameConfig | ILegacyGameConfig) => {
  return new LayoutManager(gameConfig);
};
